export default __webpack_public_path__ + "static/media/5.b38b5fe9.jpg";